// extracted by mini-css-extract-plugin
module.exports = {"root":"Radio_root__2j-qQ","label":"Radio_label__3X5yd","checkMark":"Radio_checkMark__3kA43","disabled":"Radio_disabled__xd7_E"};